import { render, staticRenderFns } from "./DialogFromAPI.vue?vue&type=template&id=954349e6&scoped=true&"
import script from "./DialogFromAPI.vue?vue&type=script&lang=js&"
export * from "./DialogFromAPI.vue?vue&type=script&lang=js&"
import style0 from "./DialogFromAPI.vue?vue&type=style&index=0&id=954349e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954349e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VProgressLinear})
